import type { CareRecipient } from "~care/types/forms/care-seeker-lead-form";

import {
  HeartWithPerson,
  PeopleWithHeart,
  Person,
} from "~care/components/ui/Icons";

type RecipientOptionItem = {
  value: CareRecipient;
  label: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
};

export const RecipientOptions: RecipientOptionItem[] = [
  {
    icon: PeopleWithHeart,
    label: "A Parent",
    value: "parent",
  },
  {
    icon: HeartWithPerson,
    label: "My Spouse",
    value: "spouse",
  },
  {
    icon: Person,
    label: "Me",
    value: "me",
  },
  {
    icon: Person,
    label: "Someone Else",
    value: "other",
  },
];

export type RecipientType = (typeof RecipientOptions)[number]["value"];

export const CareOptions = [
  [
    "mobilityAssistance",
    "Mobility Assistance",
    <ul
      className="list-inside list-disc font-light text-support-base"
      key="mobilityAssistance"
    >
      <li>
        <span className="relative -left-2">Activities of Daily Living</span>
      </li>
      <li>
        <span className="relative -left-2">Bathing and Grooming</span>
      </li>
      <li>
        <span className="relative -left-2">Meal Prep and Home Help</span>
      </li>
      <li>
        <span className="relative -left-2">Medication reminders</span>
      </li>
      <li>
        <span className="relative -left-2">Companionship</span>
      </li>
      <li>
        <span className="relative -left-2">Toileting and Incontinence</span>
      </li>
      <li>
        <span className="relative -left-2">Transportation</span>
      </li>
    </ul>,
  ],
  [
    "everydayTasks",
    "Everyday Tasks",
    <ul
      className="list-inside list-disc font-light text-support-base"
      key="everydayTasks"
    >
      <li>
        <span className="relative -left-2">Age-related dementia</span>
      </li>
      <li>
        <span className="relative -left-2">{`Parkinson's disease`}</span>
      </li>
      <li>
        <span className="relative -left-2">Heart disease or stroke</span>
      </li>
      <li>
        <span className="relative -left-2">Weight-related issues</span>
      </li>
      <li>
        <span className="relative -left-2">Cancer</span>
      </li>
      <li>
        <span className="relative -left-2">Diabetes</span>
      </li>
      <li>
        <span className="relative -left-2">COPD</span>
      </li>
    </ul>,
  ],
  [
    "memoryCare",
    "Memory care",
    <ul
      className="list-inside list-disc font-light text-support-base"
      key="memoryCare"
    >
      <li>
        <span className="relative -left-2">
          Mild Cognitive Impairment (MCI)
        </span>
      </li>
      <li>
        <span className="relative -left-2">{`Alzheimer's Disease`}</span>
      </li>
      <li>
        <span className="relative -left-2">Vascular Dementia</span>
      </li>
      <li>
        <span className="relative -left-2">Lewy Body Dementia</span>
      </li>
      <li>
        <span className="relative -left-2">Frontotemporal Dementia</span>
      </li>
      <li>
        <span className="relative -left-2">{`Parkinson's Disease`}</span>
      </li>
      <li>
        <span className="relative -left-2">Dementia</span>
      </li>
    </ul>,
  ],
  [
    "other",
    "Other",
    <ul
      className="list-inside list-disc font-light text-support-base"
      key="other"
    >
      <li>
        <span className="relative -left-2">Nurse-Directed Support</span>
      </li>
      <li>
        <span className="relative -left-2">Medication Management</span>
      </li>
      <li>
        <span className="relative -left-2">Glucose Checks</span>
      </li>
      <li>
        <span className="relative -left-2">Wound Care</span>
      </li>
    </ul>,
  ],
] as const;

export type CareOptionType = (typeof CareOptions)[number][0];
